import React, { useEffect, useState } from 'react';
import { makeRequest } from "../../utils/httpRequest";
import Config from "../../core/config";
import { useRecoilState } from "recoil";
import { loadingAtom } from "../../atoms";import { formatDateTimeString, formatDateString } from "../../utils/utils";
import StatusSelect from "./StatusSelect";

const apiUrl = Config.apiUrl;

const AfterSaleViewer = ({ afterSaleId, onClose, onStatusChange }) => {
    const [afterSale, setAfterSale] = useState(null);
    const [, setLoading] = useRecoilState(loadingAtom);
    const [selectedStatus, setSelectedStatus] = useState('');

    const typeLabels = {
        COMPLAINT: 'Reclamação',
        WARRANTY: 'Garantia',
        REPAIR: 'Reparo',
        MAINTENANCE: 'Manutenção',
        RETURN: 'Devolução',
        EXCHANGE: 'Troca',
        OTHER: 'Outro'
    };

    useEffect(() => {
        async function fetchAfterSale() {
            try {
                setLoading(true);
                const url = apiUrl + '/api/aftersales/id=' + afterSaleId;
                const response = await makeRequest(url, 'GET');
                setAfterSale(response);
                setSelectedStatus(response.status);
            } catch (error) {
                console.error('Error fetching after sale:', error);
            } finally {
                setLoading(false);
            }
        }

        if (afterSaleId) {
            fetchAfterSale();
        }
    }, [afterSaleId]);

    const handleStatusChange = async (newStatus) => {
        const statusLabels = {
            PENDING: 'Pendente',
            RESOLVED: 'Resolvido',
            CANCELED: 'Cancelado'
        };
        
        const confirmed = window.confirm(
            `Confirma a alteração do status para "${statusLabels[newStatus]}"?`
        );
        
        if (confirmed) {
            try {
                setLoading(true);
                const updatedAfterSale = { ...afterSale, status: newStatus };
                const url = apiUrl + '/api/aftersales';
                await makeRequest(url, 'PUT', {
                    'Content-Type': 'application/json',
                }, JSON.stringify(updatedAfterSale));
                
                // Fechar o modal e atualizar a lista
                if (onStatusChange) {
                    onStatusChange();
                }
                if (onClose) {
                    onClose();
                }
            } catch (error) {
                console.error('Error updating status:', error);
                alert('Erro ao atualizar o status.');
                setSelectedStatus(afterSale.status);
            } finally {
                setLoading(false);
            }
        } else {
            setSelectedStatus(afterSale.status);
        }
    };

    if (!afterSale) {
        return <div>Carregando...</div>;
    }

    return (
        <div style={{ padding: '20px', maxWidth: '800px', overflow: 'visible' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', position: 'relative', zIndex: 1 }}>
                <h2>Pós-Venda {afterSale.code}</h2>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <span>Status:</span>
                    <StatusSelect
                        value={selectedStatus}
                        onChange={(newStatus) => handleStatusChange(newStatus)}
                    />
                </div>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', marginTop: '20px' }}>
                <div>
                    <strong>Cliente:</strong>
                    <div>{afterSale.customerName || '-'}</div>
                </div>
                <div>
                    <strong>Telefone:</strong>
                    <div>{afterSale.customerPhone || '-'}</div>
                </div>
                <div>
                    <strong>Email:</strong>
                    <div>{afterSale.customerEmail || '-'}</div>
                </div>
                <div>
                    <strong>Tipo:</strong>
                    <div>{typeLabels[afterSale.type]}</div>
                </div>
                <div>
                    <strong>Data da Venda:</strong>
                    <div>{afterSale.saleDate ? formatDateString(afterSale.saleDate) : '-'}</div>
                </div>
                <div>
                    <strong>Data do Pós-Venda:</strong>
                    <div>{afterSale.afterSaleDate ? formatDateString(afterSale.afterSaleDate) : '-'}</div>
                </div>
                <div>
                    <strong>Produto/Serviço:</strong>
                    <div>{afterSale.productName || '-'}</div>
                </div>
                {afterSale.user && (
                    <div>
                        <strong>Responsável:</strong>
                        <div>{afterSale.user.name}</div>
                    </div>
                )}
            </div>

            {afterSale.description && (
                <div style={{ marginTop: '20px' }}>
                    <strong>Descrição:</strong>
                    <div style={{ 
                        marginTop: '5px', 
                        padding: '10px', 
                        backgroundColor: '#f5f5f5', 
                        borderRadius: '4px',
                        whiteSpace: 'pre-wrap'
                    }}>
                        {afterSale.description}
                    </div>
                </div>
            )}

            {afterSale.notes && (
                <div style={{ marginTop: '20px' }}>
                    <strong>Observações:</strong>
                    <div style={{ 
                        marginTop: '5px', 
                        padding: '10px', 
                        backgroundColor: '#fff3e0', 
                        borderRadius: '4px',
                        whiteSpace: 'pre-wrap'
                    }}>
                        {afterSale.notes}
                    </div>
                </div>
            )}

            <div style={{ marginTop: '30px', textAlign: 'right' }}>
                <button onClick={onClose}>Fechar</button>
            </div>
        </div>
    );
};

export default AfterSaleViewer;
